import React, { PureComponent } from "react";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import { /*Field,*/ reduxForm } from "redux-form";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import VerticalSpace from "./components/VerticalSpace";
// import ButtonAppBar from "./components/ButtonAppBar";
// import { Route } from "react-router-dom";
import AppConfig from "../../config/appconfig.json";
import Icon from "@mdi/react";
import { mdiMagnify, mdiLoading } from "@mdi/js";
// import renderRadioButtonField from "../../components/form/RadioButton";
import KBELogo from "../account/img/kbe-Logo-66454.png";
import AirnowLogo from "../account/img/airnow_logo.png";

class AirConRegistration extends PureComponent {
  constructor(props) {
    super(props);
    let isCreateNew = true;
    let system = null;
    if (this.props.location.state) {
      if (this.props.location.state.airconsystem) {
        isCreateNew = false;
        system = this.props.location.state.airconsystem;
        //console.log(system);
      }
    }
    if (isCreateNew) {
      this.state = {
        email: this.getEmailAddressLogin(),
        customertype: "Residential",
        isCustomerTypeResidential: true,
        postalcode: "",
        hseblk: "",
        floorunit: "",
        street: "",
        building: "",
        companyname: "",
        contactperson: "",
        mobilenumber: "",
        telephone: "",
        brand: "",
        model: "",
        fancoils: "",
        isPostalCodeLoading: false,
        isPostalCodeError: false,
        isCreateNewCustomer: isCreateNew,
        isPostalCodeValid: false,
        page: 1,
        isHseblkError: false,
        isFloorunitError: false,
        isStreetError: false,
        isCompanynameError: false,
        isMobilenumberError: false,
        isBrandError: false,
        isModelError: false
      };
    } else {
      this.state = {
        email: system.Email,
        customertype: system.CustomerType,
        isCustomerTypeResidential: system.CustomerType === "Residential",
        postalcode: system.PostalCode,
        hseblk: system.Block,
        floorunit: system.Unit,
        street: system.Street,
        building: system.Building,
        companyname: system.Company,
        contactperson: system.ContactPerson,
        mobilenumber: system.MobileNo,
        telephone: "",
        brand: system.Brand,
        model: system.Model,
        fancoils: system.Fancoils,
        systemSid: system.Sid,
        isPostalCodeLoading: false,
        isPostalCodeError: false,
        isCreateNewCustomer: isCreateNew,
        isPostalCodeValid: true,
        page: 1,
        isHseblkError: false,
        isFloorunitError: false,
        isStreetError: false,
        isCompanynameError: false,
        isMobilenumberError: false,
        isBrandError: false,
        isModelError: false
      };
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSearchPostCode = this.handleSearchPostCode.bind(this);
    this.handleComboChange = this.handleComboChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  getEmailAddressLogin() {
    let value = localStorage.getItem("kbeEmail");
    if (value == null) value = "";
    return value;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "postalcode") this.setState({ isPostalCodeValid: false });
    if (name === "hseblk") this.setState({ isHseblkError: false });
    if (name === "floorunit") this.setState({ isFloorunitError: false });
    if (name === "street") this.setState({ isStreetError: false });
    if (name === "brand") this.setState({ isBrandError: false });
    if (name === "model") this.setState({ isModelError: false });
    if (name === "companyname") this.setState({ isCompanynameError: false });
    if (name === "mobilenumber") this.setState({ isMobilenumberError: false });

    this.setState({
      [name]: value
    });
  }

  handleCustomerTypeChange(event) {
    if (this.state.isCustomerTypeResidential)
      this.setState({
        isCustomerTypeResidential: false,
        customertype: "Commercial",
        isCompanynameError: false
      });
    else
      this.setState({
        isCustomerTypeResidential: true,
        customertype: "Residential",
        isCompanynameError: false
      });
  }

  handleComboChange(event) {
    const typeVal = event.value;
    if (typeVal) this.setState({ type: typeVal });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.isPostalCodeValid === false) {
      this.setState({ isPostalCodeError: true, page: 1 });
      return;
    }
    if (this.state.hseblk === "") {
      this.setState({ page: 1, isHseblkError: true });
      return;
    }
    if (this.state.floorunit === "") {
      this.setState({ page: 1, isFloorunitError: true });
      return;
    }
    if (this.state.street === "") {
      this.setState({ page: 1, isStreetError: true });
      return;
    }
    if (!this.state.isCustomerTypeResidential && this.state.companyname === "") {
      this.setState({ page: 2, isCompanynameError: true });
      return;
    }
    if (this.state.mobilenumber === "") {
      this.setState({ page: 2, isMobilenumberError: true });
      return;
    }
    // if (this.state.brand === "") {
    //   this.setState({ page: 3, isBrandError: true });
    //   return;
    // }
    // if (this.state.model === "") {
    //   this.setState({ page: 3, isModelError: true });
    //   return;
    // }

    const kbeSid = localStorage.getItem("kbeSid");
    const fancoils = this.state.fancoils ? this.state.fancoils : 0;
    let request = null;
    let url = null;
    if (this.state.isCreateNewCustomer) {
      url = `${AppConfig.BACK_END_URL}/APIClient/UpdateCustomer`;
      request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Sid: kbeSid,
          CustomerType: this.state.customertype,
          Company: this.state.companyname,
          ContactPerson: this.state.contactperson,
          ContactNo: this.state.mobilenumber,
          Email: this.state.email,
          Block: this.state.hseblk,
          Street: this.state.street,
          Unit: this.state.floorunit,
          Building: this.state.building,
          Postal: this.state.postalcode,
          Brand: this.state.brand,
          Model: this.state.model,
          Type: this.state.type,
          Fancoils: fancoils
        })
      };
    }
    else {
      url = `${AppConfig.BACK_END_URL}/APIClient/UpdateCustomerSystem`;
      request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Sid: this.state.systemSid,
          Block: this.state.hseblk,
          Street: this.state.street,
          Unit: this.state.floorunit,
          Building: this.state.building,
          PostalCode: this.state.postalcode,
          Brand: this.state.brand,
          Model: this.state.model,
          Type: this.state.type,
          Fancoils: fancoils,
          DefaultAddress: "N"
        })
      };
    }
    // console.log(request);
    let isUpdateCustomerFailed = false;
    fetch(url, request)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isUpdateCustomerFailed = true;
        }
        return response.json();
      })
      .then(json => {
        // console.log(json);
        if (isUpdateCustomerFailed) {
          // const respObj = JSON.parse(json);
          // console.log(respObj);
        } else {
          window.location.href = "/";
          // console.log("succeed");
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when updating customer. Please try again."
        );
      });
  }

  handleSearchPostCode() {
    this.setState({ isPostalCodeLoading: true, isPostalCodeError: false, isHseblkError: false, isFloorunitError: false, isStreetError: false });
    // Call Back-End Services
    fetch(
      `${AppConfig.BACK_END_URL}/APIPostalCode/Get?postalcode=` +
      this.state.postalcode
    )
      .then(response => {
        // console.log(response);
        return response.json();
      })
      .then(json => {
        if (json) {
          if (json.length > 0) {
            // console.log(json[0]);
            if (json[0].AddressType === "") {
              this.setState({
                isPostalCodeError: true,
                isPostalCodeValid: false
              });
            } else {
              this.setState({
                street: json[0].Street,
                building: json[0].Building,
                hseblk: json[0].BuildingNumber,
                isPostalCodeValid: true
              });
            }
          }
        }
        this.setState({ isPostalCodeLoading: false });
      })
      .catch(() => {
        console.log("error");
        this.setState({ isPostalCodeLoading: false });
      });
  }

  render() {
    // const AppointmentButton = props => (
    //   <Route
    //     render={({ history }) => (
    //       <div>
    //         <Button
    //           variant="outlined"
    //           style={{ width: "100%" }}
    //           onClick={() => {
    //             history.push("/register_appt");
    //           }}
    //         >
    //           Book Appt
    //         </Button>
    //       </div>
    //     )}
    //   />
    // );

    const SaveAirconSystemButton = props => (
      <div>
        <Button variant="outlined" style={{ width: "100%" }} type="submit">
          Save
        </Button>
      </div>
    );

    const PostalCodeErrorMessage = props => {
      if (this.state.isPostalCodeError) {
        return (
          <span className="form__form-group-field list-text-red">
            No result found
          </span>
        );
      }
      return null;
    };

    const HseblkErrorMessage = props => {
      if (this.state.isHseblkError) {
        return (
          <span className="form__form-group-field list-text-red">
            Hse/Blk is required
          </span>
        );
      }
      return null;
    };

    const FloorunitErrorMessage = props => {
      if (this.state.isFloorunitError) {
        return (
          <span className="form__form-group-field list-text-red">
            Floor/Unit is required
          </span>
        );
      }
      return null;
    };

    const StreetErrorMessage = props => {
      if (this.state.isStreetError) {
        return (
          <span className="form__form-group-field list-text-red">
            Street is required
          </span>
        );
      }
      return null;
    };

    const CompanynameErrorMessage = props => {
      if (this.state.isCompanynameError) {
        return (
          <span className="form__form-group-field list-text-red">
            Company Name is required
          </span>
        );
      }
      return null;
    };

    const MobilenumberErrorMessage = props => {
      if (this.state.isMobilenumberError) {
        return (
          <span className="form__form-group-field list-text-red">
            Mobile Number is required
          </span>
        );
      }
      return null;
    };

    const BrandErrorMessage = props => {
      if (this.state.isBrandError) {
        return (
          <span className="form__form-group-field list-text-red">
            Aircon Brand is required
          </span>
        );
      }
      return null;
    };

    const ModelErrorMessage = props => {
      if (this.state.isModelError) {
        return (
          <span className="form__form-group-field list-text-red">
            Aircon Model is required
          </span>
        );
      }
      return null;
    };

    return (
      <div>
        {/* <ButtonAppBar /> */}
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                {this.state.isCustomerTypeResidential === true ? (
                  <img src={AirnowLogo} alt="logo" />) : (
                    <img src={KBELogo} alt="logo" />)}
              </div>
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Aircon and Address Details</h4>
                </center>
                <br />
              </div>
              <form
                className="form form--horizontal"
                onSubmit={this.handleSubmit}
              >
                {this.state.page === 1 && <div id="form-step-1">
                  <div className="form__form-group">
                    <label className="form__form-group-label">
                      Customer Type:{" "}
                    </label>
                    <div className="form__form-group-field">
                      {/* <Field
                      name="customertype"
                      component={renderRadioButtonField}
                      label="Residential"
                      radioValue="Residential"
                      onChange={this.handleCustomerTypeChange}
                      defaultChecked
                    /> */}
                      <label className="radio-btn">
                        <input
                          className="radio-btn__radio"
                          name="customertype"
                          type="radio"
                          onChange={this.handleCustomerTypeChange}
                          checked={this.state.isCustomerTypeResidential === true}
                        />
                        <span className="radio-btn__radio-custom" />
                        <span className="radio-btn__label">Residential</span>
                      </label>
                      <label className="radio-btn">
                        <input
                          className="radio-btn__radio"
                          name="customertype"
                          type="radio"
                          onChange={this.handleCustomerTypeChange}
                          checked={this.state.isCustomerTypeResidential === false}
                        />
                        <span className="radio-btn__radio-custom" />
                        <span className="radio-btn__label">Commercial</span>
                      </label>
                      {/* <Field
                      name="customertype"
                      component={renderRadioButtonField}
                      label="Commercial"
                      radioValue="Commercial"
                      onChange={this.handleCustomerTypeChange}
                    /> */}
                    </div>
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">
                      Postal Code*:{" "}
                    </label>
                    <div className="form__form-group-field">
                      <input
                        name="postalcode"
                        type="text"
                        placeholder="Postal Code"
                        value={this.state.postalcode}
                        onChange={this.handleInputChange}
                        required={true}
                      />
                      <div
                        className="form__form-group-icon"
                        onClick={this.handleSearchPostCode}
                      >
                        {this.state.isPostalCodeLoading ? (
                          <Icon path={mdiLoading} spin={1} />
                        ) : (
                            <Icon path={mdiMagnify} />
                          )}
                      </div>
                    </div>
                    <PostalCodeErrorMessage />
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Hse/Blk*: </label>
                    <div className="form__form-group-field">
                      <input
                        name="hseblk"
                        type="text"
                        placeholder="Hse/Blk"
                        onChange={this.handleInputChange}
                        value={this.state.hseblk}
                        required={true}
                      />
                      <label
                        className="form__form-group-label"
                        style={{ marginLeft: "10px", marginRight: "10px" }}
                      >
                        {" "}
                        Floor/Unit*:{" "}
                      </label>
                      <input
                        name="floorunit"
                        type="text"
                        placeholder="Floor/Unit"
                        onChange={this.handleInputChange}
                        value={this.state.floorunit}
                        required={true}
                      />
                    </div>
                    <HseblkErrorMessage />
                    <FloorunitErrorMessage />
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Street*: </label>
                    <div className="form__form-group-field">
                      <input
                        name="street"
                        type="text"
                        placeholder="Street"
                        onChange={this.handleInputChange}
                        value={this.state.street}
                        required={true}
                      />
                    </div>
                    <StreetErrorMessage />
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Building: </label>
                    <div className="form__form-group-field">
                      <input
                        name="building"
                        type="text"
                        placeholder="Building"
                        onChange={this.handleInputChange}
                        value={this.state.building}
                      />
                    </div>
                  </div>
                </div>
                }
                {this.state.page === 2 &&
                  <div id="form-step-2" className="form__form-group">
                    <div className="form__form-group">
                      <label className="form__form-group-label">
                        Company Name:
                  </label>
                      <div className="form__form-group-field">
                        <input
                          name="companyname"
                          type="text"
                          placeholder="Company Name"
                          value={this.state.companyname}
                          onChange={this.handleInputChange}
                          required={this.state.isCustomerTypeResidential === false}
                          disabled={this.state.isCustomerTypeResidential === true}
                        />
                      </div>
                      <CompanynameErrorMessage />
                    </div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">
                        Contact Person:
                  </label>
                      <div className="form__form-group-field">
                        <input
                          name="contactperson"
                          type="text"
                          placeholder="Contact Person"
                          value={this.state.contactperson}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">
                        Mobile Number*:{" "}
                      </label>
                      <div className="form__form-group-field">
                        <input
                          name="mobilenumber"
                          type="text"
                          placeholder="Mobile Number"
                          value={this.state.mobilenumber}
                          onChange={this.handleInputChange}
                          required={true}
                        />
                      </div>
                      <MobilenumberErrorMessage />
                    </div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">Telephone:</label>
                      <div className="form__form-group-field">
                        <input
                          name="telephone"
                          type="text"
                          placeholder="Telephone"
                          value={this.state.telephone}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                }
                {this.state.page === 3 &&
                  <div id="form-step-3" className="form__form-group">
                    <div className="form__form-group">
                      <label className="form__form-group-label">
                        Aircon Brand*:
                  </label>
                      <div className="form__form-group-field">
                        <input
                          name="brand"
                          type="text"
                          placeholder="Brand"
                          value={this.state.brand}
                          onChange={this.handleInputChange}
                        // required={true}
                        />
                      </div>
                      <BrandErrorMessage />
                    </div>
                    <div className="form__form-group">
                      <label className="form__form-group-label">
                        Aircon Model*:
                  </label>
                      <div className="form__form-group-field">
                        <input
                          name="model"
                          type="text"
                          placeholder="Model"
                          value={this.state.model}
                          onChange={this.handleInputChange}
                        // required={true}
                        />
                      </div>
                      <ModelErrorMessage />
                    </div>
                    {/* <div className="form__form-group">
                  <label className="form__form-group-label">Type*: </label>
                  <div className="form__form-group-field">
                    <Field
                      name="type"
                      component={renderSelectField}
                      options={[
                        { value: "Inverter", label: "Inverter" },
                        { value: "NonInventer", label: "Non-Inverter" }
                      ]}
                      value={this.state.type}
                      onChange={this.handleComboChange}
                      required={true}
                    />
                  </div>
                </div> */}
                    <div className="form__form-group">
                      <label className="form__form-group-label">
                        Fancoils (FCU):{" "}
                      </label>
                      <div className="form__form-group-field">
                        <input
                          name="fancoils"
                          type="number"
                          placeholder="Fancoils"
                          min="0"
                          step="1"
                          value={this.state.fancoils}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    {/* <div className="form__form-group">
                      <Grid container spacing={24}>
                        <Grid item xs={3}>
                          <AppointmentButton />
                        </Grid>
                        <Grid item xs={6}>
                          <SaveAirconSystemButton />
                        </Grid>
                        <Grid item xs={3}>
                        </Grid>
                      </Grid>
                      <VerticalSpace />
                    </div> */}
                  </div>
                }
                <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={6}>
                      <Button variant="outlined" style={{ width: "100%" }} type="button" disabled={this.state.page === 1} onClick={this.previousPage}>
                        Back</Button>
                    </Grid>
                    <Grid item xs={6}>
                      {this.state.page === 2 ? (
                        this.state.isCreateNewCustomer ?
                          <SaveAirconSystemButton /> :
                          <Button variant="outlined" style={{ width: "100%" }} type="button" disabled={true}>
                            Next</Button>
                      ) : (
                          <Button variant="outlined" style={{ width: "100%" }} type="button" onClick={this.nextPage}>
                            Next</Button>
                        )}
                    </Grid>
                  </Grid>
                </div>
                {this.state.isCreateNewCustomer ? <div></div> :
                  <div className="form__form-group">
                    <Grid container spacing={24}>
                      <Grid item xs={12}>
                        <SaveAirconSystemButton />
                      </Grid>
                    </Grid>
                    <VerticalSpace />
                  </div>
                }
                <VerticalSpace />
              </form>
              <SimpleBottomNavigation />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "airconregistration_form" // a unique identifier for this form
})(AirConRegistration);



// WEBPACK FOOTER //
// ./src/pages/main/AirConRegistration.js